import { Box, Typography } from '@mui/material';
import { MapPin } from 'lucide-react';

const font = "'Manrope', sans-serif";

export const PropertyAddressMapCard = ({
  address,
  locality,
  compact = false,
}: {
  address: string;
  locality: string;
  compact?: boolean;
}) => (
  <Box
    sx={{
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: compact ? '12px' : '14px',
      bgcolor: 'var(--tx-fill)',
      border: 0,
    }}>
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        height: compact ? 74 : 92,
        bgcolor: '#343633',
        backgroundImage: [
          'linear-gradient(28deg, transparent 47%, rgba(187,183,175,0.13) 48%, rgba(187,183,175,0.13) 51%, transparent 52%)',
          'linear-gradient(150deg, transparent 42%, rgba(187,183,175,0.09) 43%, rgba(187,183,175,0.09) 46%, transparent 47%)',
        ].join(', '),
      }}>
      <Box
        sx={{
          position: 'absolute',
          left: '58%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: 28,
          height: 28,
          display: 'grid',
          placeItems: 'center',
          borderRadius: '50% 50% 50% 0',
          rotate: '-45deg',
          bgcolor: 'var(--tx-fill-2)',
          color: 'var(--tx-text)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        }}>
        <MapPin size={14} style={{ rotate: '45deg' }} />
      </Box>
    </Box>
    <Box sx={{ mt: 'auto', p: compact ? '18px 14px 14px' : '14px 16px 16px' }}>
      {compact && (
        <Typography sx={{ fontFamily: font, fontSize: 10, color: 'text.secondary', mb: '3px' }}>
          PROPERTY
        </Typography>
      )}
      <Typography
        sx={{ fontFamily: font, fontSize: compact ? 15 : 17, fontWeight: 600, lineHeight: 1.35 }}>
        {address}
      </Typography>
      <Typography
        sx={{ fontFamily: font, fontSize: compact ? 11 : 12, color: 'text.secondary', mt: '2px' }}>
        {locality}
      </Typography>
    </Box>
  </Box>
);
